import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoBlanco from '../../assets/logoblanco.png';

export const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <nav className="navbar">
            <div className="container navbar-container">
                <Link to="/" className="navbar-logo">
                    <img src={logoBlanco} alt="R&M Estudio Contable" style={{ height: '50px' }} />
                </Link>

                <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
                    <Link to="/" onClick={() => setIsOpen(false)}>Inicio</Link>
                    <Link to="/servicios" onClick={() => setIsOpen(false)}>Servicios</Link>
                    <Link to="/nosotros" onClick={() => setIsOpen(false)}>Nosotras</Link>
                    <Link to="/contacto" onClick={() => setIsOpen(false)}>Contacto</Link>
                    <Link to="/contacto" className="btn-primary mobile-only" onClick={() => setIsOpen(false)}>Agendar Consulta</Link>
                </div>

                <div className="navbar-actions">
                    <Link to="/contacto" className="btn-primary desktop-only">Agendar Consulta</Link>
                    <div className="hamburger" onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </nav>
    );
};
